<div class="mt-1 historyscroll">
  <cdk-accordion>
    <cdk-accordion-item *ngFor="let item of list; let index = index; let even = even; let isFirst = first;"
      #accordionItem="cdkAccordionItem" [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded" [attr.aria-controls]="'accordion-body-' + index">
      <div class="accordion-circle py-3 circle-{{ item?.status?.type }}">
        <div class="after-circle d-flex">
          <div *ngIf="!isFirst; else otherHistoryItem;" class="w-80-px">
            <div class="date">{{ item?.time | date : 'd MMM yyyy' }}</div>
            <div class="date">{{ item?.time | date : 'h:mm aaa' }}</div>
          </div>
          <ng-template #otherHistoryItem>
            <div class="w-80-px">
              <div class="date bold" matTooltip="{{ item?.time | date : 'd MMM yyyy h:mm aaa' }}"
                [matTooltipPosition]="'above'">{{ MESSAGES?.NOW }}</div>
            </div>
          </ng-template>
        </div>
        <div class="d-flex align-items-center space-around">
          <small class="status-{{ item?.status?.type }}">
            {{ item?.status?.title | uppercase }}
          </small>
          <span class="ms-1">
            <mat-icon class="f-20 cursor" matTooltip="{{ MESSAGES?.HISTORY_STATUS 
                | replace:'[HISTORY_OF]': (name | titlecase) 
                | replace:'[STATUS]': (item?.value ? MESSAGES?.DISCONNECTED : MESSAGES?.CONNECTED)  
              }}" [matTooltipPosition]="'above'" [inline]="true">
              info_outline
            </mat-icon>
          </span>
        </div>
      </div>
      <div class="accordion-item"></div>
    </cdk-accordion-item>
  </cdk-accordion>
</div>